<template>
  <div :class="_.block">
    <template v-if="isJoint">
      <div :class="_.merchant">
        <div
          :class="[_.hd, _._hairlineBottom]"
          @click="handleJointGoodsClick(order.commodities[0].commodityId)"
        >
          <img :src="order.commodities[0].pic" :class="_.cover" />
          <div :class="_.content">
            <div :class="_.top">
              <div :class="[_.name, _._ellipsis2]">
                {{ order.commodities[0].name }}
              </div>
              <div :class="_.count">x{{ order.commodities[0].quantity }}</div>
            </div>
            <div :class="_.bottom">￥{{ order.commodities[0].price }}</div>
          </div>
        </div>
        <div :class="_.bd">
          <div :class="_.caption">组合内包含商品</div>
          <div
            v-for="(item, index) in order.childOrderList"
            :key="index"
            :class="_.goods"
            @click="handleSubOrderClick(item.orderNo)"
          >
            <img :src="item.commodities[0].pic" :class="_.cover" />
            <div :class="_.content">
              <div :class="_.top">
                <div :class="[_.name, _._ellipsis2]">
                  {{ item.commodities[0].name }}
                </div>
                <div :class="_.status">
                  {{
                    item.status !== 0 &&
                    item.status !== 901 &&
                    item.status !== 902 &&
                    item.commodities[0].saleAfterStatus !== 99 &&
                    item.commodities[0].saleAfterName
                      ? item.commodities[0].saleAfterName
                      : item.statusName
                  }}
                </div>
              </div>
              <div :class="_.middle">x{{ item.commodities[0].quantity }}</div>
              <div v-if="item.status !== 0" :class="_.bottom">
                <div :class="[_.left, _._ellipsisFlex]">
                  物流信息：{{
                    (item.lastExpressTrace &&
                      item.lastExpressTrace.actionInfo) ||
                    '商品尚未发货或等待揽收'
                  }}
                </div>
                <x-icon name="arrow" :class="_.arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div :class="[_.hd, _._hairlineBottom]" @click="handleMartClick">
        <img :src="require('./images/店铺.png')" :class="_.icon" />
        <div :class="[_.name, _._ellipsis]">{{ order.merchantName }}</div>
        <van-icon name="arrow" :class="_.arrow" />
      </div>

      <div :class="[_.bd, _._hairlineBottom]">
        <div
          v-for="item in order.commodities"
          :key="item.commodityId"
          :class="_.item"
        >
          <div :class="_.main" @click="handleGoodsClick(item)">
            <img :src="item.pic" :class="_.cover" />
            <div :class="_.content">
              <div :class="_.left">
                <div :class="[_.name, _._ellipsis2]">{{ item.name }}</div>
                <div :class="_.desc">{{ item.skuSpecs }}</div>
              </div>
              <div :class="_.right">
                <div :class="_.price">¥{{ item.unitPrice }}</div>
                <div :class="_.count">x{{ item.quantity }}</div>
              </div>
            </div>
          </div>
          <div :class="_.actions">
            <div
              v-if="
                order.shipType === 0 &&
                order.orderActivityType !== 12 &&
                order.status !== 0 &&
                order.status !== 901 &&
                order.status !== 902 &&
                (item.saleAfterStatus === 99 || !!item.saleAfterName)
              "
              :class="_.button"
              @click="handleAfterSalesClick(item)"
            >
              {{
                item.saleAfterStatus === 99 ? '申请售后' : item.saleAfterName
              }}
            </div>

            <div
              v-if="order.status === 204"
              :class="[_.button, _.left]"
              @click="handleExchangeClick(item)"
            >
              兑换商品
            </div>
          </div>
        </div>
      </div>
    </template>

    <div :class="[_.ft, isBriefFold && _.fold]">
      <div :class="_.item">
        <div :class="_.label">商品总额</div>
        <div :class="_.value">¥{{ order.orderAmount }}</div>
      </div>
      <div :class="_.item" @click="handlePostFeeClick">
        <div :class="_.label">运费</div>
        <div :class="_.value">¥{{ order.postFee }}</div>
        <x-icon v-if="isJoint" name="arrow" :class="_.arrow" />
      </div>
      <div v-if="!order.channelDiscountAmount" :class="_.item">
        <div :class="_.label">优惠金额</div>
        <div :class="[_.value, _.red]">
          {{ order.discountAmount ? '-' : '' }}¥{{ order.discountAmount }}
        </div>
      </div>
      <div v-if="order.integral" :class="_.item">
        <div :class="_.label">多彩豆</div>
        <div :class="[_.value, _.red]">-{{ order.integral }}</div>
      </div>
      <div v-if="order.channelDiscountAmount" :class="_.item">
        <div :class="_.label">抵扣方式</div>
        <div :class="[_.value, _.red]">
          {{ order.channelDiscountAmount }}
        </div>
      </div>
      <div :class="_.brief" @click="handleBriefClick">
        实付款：
        <div :class="_.price">
          {{ order.orderActivityType === 12 ? '￥0.00' : order.payAmount }}
        </div>
        <van-icon
          :name="isBriefFold ? 'arrow-down' : 'arrow-up'"
          :class="_.arrow"
        />
      </div>
    </div>

    <van-action-sheet
      v-if="isJoint"
      v-model="showPostFeeDetail"
      round
      safe-area-inset-bottom
      title="运费详情"
      :class="_.postFeeDetail"
    >
      <div :class="_.bd">
        <div
          v-for="(item, index) in order.childOrderList"
          :key="index"
          :class="_.item"
        >
          <div :class="[_.name, _._ellipsis]">
            {{ item.commodities[0].name }}
          </div>
          <div :class="_.price">¥{{ item.commodities[0].postFee }}</div>
        </div>
      </div>
      <div :class="_.ft">合计：¥{{ order.postFee }}</div>
    </van-action-sheet>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    props: {
      order: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      isBriefFold: true,
      showPostFeeDetail: false,
    }),

    computed: {
      isJoint() {
        return this.order.orderClassify === 7 && !!this.order.parentOrderFlag
      },
    },

    methods: {
      handleMartClick() {
        navigateTo('MartIndex', {
          id: this.order.merchantId,
        })
      },

      handleGoodsClick(item) {
        navigateTo('GoodsIndex', {
          id: item.commodityId,
        })
      },

      async handleAfterSalesClick(item) {
        if (item.saleAfterStatus === 99) {
          await this.$track.push({
            name: '我的订单-申请售后',
            id: 'be49d334-e6b0-4f35-8aa6-ad8c787affba',
          })
          navigateTo('AfterSalesRequestChoose', {
            commodityId: item.commodityId,
            skuId: item.skuId,
            orderNo: this.order.orderNo,
          })
        } else {
          await this.$track.push({
            name: '我的订单-售后状态',
            id: '13362994-ddc5-4a49-b1a7-a3a1ad08a1db',
          })
          navigateTo('AfterSalesDetail', {
            id: item.saleAfterId,
          })
        }
      },

      handleExchangeClick() {
        navigateTo('ExchangeIndex', {
          id: this.order.commodities[0].commodityId,
          orderNo: this.order.orderNo,
        })
      },

      handleJointGoodsClick(goodsId) {
        navigateTo('JointStdGoodsIndex', { id: goodsId })
      },

      handlePostFeeClick() {
        if (this.isJoint) {
          this.showPostFeeDetail = true
        }
      },

      handleBriefClick() {
        this.isBriefFold = !this.isBriefFold
      },

      handleSubOrderClick(orderNo) {
        navigateTo('OrderDetail', {
          orderNo,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .block {
    margin-top: 12px;
    padding: 12px;
    background: #ffffff;
    border-radius: 8px;

    > {
      .hd {
        display: flex;
        align-items: center;
        padding-bottom: 7px;
        overflow: hidden;

        .icon {
          flex-shrink: 0;
          width: 16px;
          height: 16px;
        }

        .name {
          margin-left: 8px;
          font-size: 14px;
          font-weight: bold;
          color: #222222;
          line-height: 20px;
        }

        .arrow {
          margin-left: 6px;
          flex-shrink: 0;
          font-size: 14px;
          color: #bebebe;
        }
      }

      .bd {
        padding: 12px 0;

        .item {
          .main {
            display: flex;

            .cover {
              flex-shrink: 0;
              width: 85px;
              height: 85px;
              border-radius: 8px;
              object-fit: cover;
            }

            .content {
              flex-grow: 1;
              margin-left: 12px;
              display: flex;

              .left {
                flex-grow: 1;

                .name {
                  font-size: 14px;
                  color: #222222;
                  line-height: 20px;
                  word-break: break-all;
                }

                .desc {
                  margin-top: 8px;
                  font-size: 12px;
                  color: #888888;
                  line-height: 16px;
                }
              }

              .right {
                flex-shrink: 0;
                width: 90px;
                text-align: right;

                .price {
                  font-size: 12px;
                  color: #1d1d1c;
                  line-height: 17px;
                }

                .count {
                  margin-top: 5px;
                  font-size: 12px;
                  color: #888888;
                  line-height: 16px;
                }
              }
            }
          }

          .actions {
            margin-top: 8px;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .button {
              border-radius: 17px;
              border: 1px solid #aaaaaa;
              font-size: 12px;
              color: #666666;
              line-height: 17px;
              padding: 4px 16px;
            }

            .left {
              margin-left: 8px;
              background: #ff111c;
              color: #ffffff;
              border: 1px solid #ff111c;
            }

            &:empty {
              display: none;
            }
          }
        }
      }

      .ft {
        padding-top: 12px;

        .item {
          display: flex;
          align-items: center;

          .label {
            flex-grow: 1;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
          }

          .value {
            font-size: 14px;
            color: #222222;
            line-height: 20px;

            &.red {
              color: #ff111c;
            }
          }

          .arrow {
            font-size: 14px;
            color: #222;
          }

          &:not(:first-child) {
            margin-top: 12px;
          }
        }

        .brief {
          margin-top: 12px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          color: #222222;
          line-height: 20px;

          .price {
            font-size: 16px;
            color: #ff202a;
            font-weight: bold;
            line-height: 22px;
          }

          .arrow {
            margin-left: 8px;
            font-size: 12px;
            color: #222222;
          }
        }

        &.fold {
          .item {
            display: none;
          }

          .brief {
            margin-top: 0;
          }
        }
      }
    }
  }

  .merchant {
    .hd {
      display: flex;
      align-items: stretch;
      padding-bottom: 12px;
      font-size: 0;

      .cover {
        flex-shrink: 0;
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 4px;
      }

      .content {
        flex-grow: 1;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .top {
          display: flex;

          .name {
            flex-grow: 1;
            font-size: 15px;
            font-weight: var(--bold-value);
            color: #222222;
            line-height: 18px;
          }

          .count {
            margin-left: 14px;
            flex-shrink: 0;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
          }
        }

        .bottom {
          font-size: 16px;
          font-weight: var(--bold-value);
          color: #ff111c;
          line-height: 22px;
        }
      }
    }

    .bd {
      .caption {
        margin-top: 12px;
        font-size: 14px;
        font-weight: var(--bold-value);
        color: #222222;
        line-height: 22px;
      }

      .goods {
        margin-top: 12px;
        display: flex;
        align-items: stretch;
        background: #f8f8f8;
        border-radius: 8px;
        padding: 8px;

        .cover {
          flex-shrink: 0;
          width: 66px;
          height: 66px;
          object-fit: cover;
          border-radius: 8px;
        }

        .content {
          margin-left: 12px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .top {
            display: flex;

            .name {
              flex-grow: 1;
              font-size: 14px;
              color: #333;
              line-height: 20px;
            }

            .status {
              margin-left: 14px;
              flex-shrink: 0;
              font-size: 14px;
              color: #ff111c;
              line-height: 20px;
            }
          }

          .middle {
            font-size: 14px;
            color: #999999;
            line-height: 20px;
          }

          .bottom {
            flex-shrink: 0;
            display: flex;
            align-items: center;

            .left {
              flex-grow: 1;
              font-size: 12px;
              color: #999999;
              line-height: 17px;
            }

            .arrow {
              margin-left: 10px;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }
  }

  .postFeeDetail {
    .bd {
      padding-top: 12px;

      .item {
        display: flex;
        padding: 0 15px;

        .name {
          flex-grow: 1;
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }

        .price {
          margin-left: 18px;
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }

        + .item {
          margin-top: 12px;
        }
      }
    }

    .ft {
      margin-top: 20px;
      padding: 0 20px;
      font-size: 14px;
      font-weight: var(--bold-value);
      color: #ff111c;
      line-height: 20px;
      height: 50px;
      line-height: 50px;
      text-align: right;
      box-shadow: 0px -2px 2px 0px #f5f5f5;
    }
  }
</style>
